export default function contactFormInit() {
    // Contact Form
    $(function () {
        $(".error").hide();
        $(".button").click(function () {
            // validate and process form here

            $(".error").hide();
            var name = $("input#name").val();
            if (name == "") {
                $("label#name_error").show();
                $("input#name").focus();
                return false;
            }
            var email = $("input#email").val();
            if (email == "") {
                $("label#email_error").show();
                $("input#email").focus();
                return false;
            }
            var message = $("textarea#message").val();
            if (message == "") {
                $("label#message_error").show();
                $("textarea#message").focus();
                return false;
            }
            var formTitle = $("input#title").val();
            var receiverEmail = "dbiancamano@umass.edu";
            var senderEmail = "contact@theminutemenclub.com"; // This email is set up through AWS (Simple Email Service)
            var replyEmail = $("input#email").val();

            $.ajax({
                type: "POST",
                url: "https://y4590nvwy3.execute-api.us-east-1.amazonaws.com/prod",
                contentType: "application/json",
                data: JSON.stringify({
                    name: name,
                    email: email,
                    message: message,
                    receiverEmail: receiverEmail,
                    senderEmail: senderEmail,
                    replyEmail: replyEmail,
                    formTitle: formTitle,
                }),
                success: function () {
                    $("#contact_form").html("<div id='message'></div>");
                    $("#message")
                        .html("<p class='lead'>Thank you!</p>")
                        // .append("<p>We will be in touch soon.</p>")
                        .hide()
                        .fadeIn(1000, function () {
                            // $('#message').append("<img id='checkmark' src='images/check.png' />");
                        });
                },
            });
            return false;
        });
    });
}
